// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EbtL1","content":"styles_content__Esg8Z","row":"styles_row__1BRlG","footer":"styles_footer__3B_Kj","phraseLength":"styles_phraseLength__1iPXT"};